/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreferredIcon/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PreferredIcon({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/PreferredIcon"
  
}) {
let profilePatientPreferredContactMethodValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'preferred_contact_method',
})
let emailIdValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'id',
})
let aggregateData = fromAggregate.equals(profilePatientPreferredContactMethodValueData, emailIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="profile_patient.preferred_contact_method"
 data="email.id"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 text="Set as preferred contact"
/>
{children}
</React.Fragment>)
}